/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Categorias from "./Componentes/Home_Categorias";
import Home_Mas_Vendidos from "./Componentes/Home_Mas_Vendidos";
import Testimonios from "./Componentes/SubComponentes/Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import {SECCIONES} from "../../Constantes";

import {Splide, SplideSlide} from "@splidejs/react-splide";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0, zIndex: 1}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Home_Mas_Vendidos/>
            </Grid>

            <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Testimonios/>
            </Grid>

            <Grid id={SECCIONES[2]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home  